var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.4 253.8",
    style: {
      enablebackground: "new 0 0 210.4 253.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F6921E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.1,193.9H47.6c-2.8,0-5.3,2-5.5,4.8c-0.3,3.1,2.2,5.8,5.3,5.8h115.4c2.8,0,5.3-2,5.6-4.8 C168.6,196.5,166.2,193.9,163.1,193.9L163.1,193.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,59.9h84.4c2.8,0,5.3-2,5.6-4.8c0.3-3.1-2.2-5.8-5.3-5.8H47.6c-2.8,0-5.3,2-5.5,4.8 C41.8,57.3,44.3,59.9,47.4,59.9L47.4,59.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,97.5c-3.1,0-5.5,2.6-5.3,5.8c0.2,2.8,2.8,4.8,5.5,4.8h115.2c2.8,0,5.3-2,5.6-4.8c0.3-3.1-2.2-5.8-5.3-5.8 H47.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.1,145.7H47.6c-2.8,0-5.3,2-5.5,4.8c-0.3,3.1,2.2,5.8,5.3,5.8h115.4c2.8,0,5.3-2,5.6-4.8 C168.6,148.3,166.2,145.7,163.1,145.7L163.1,145.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,47.7L172.1,1.9l0,0l-0.3-0.4c-0.9-1-2.2-1.5-3.6-1.5H5.3C2.4,0,0,2.4,0,5.3v243.1c0,2.9,2.4,5.4,5.3,5.4 h199.7c2.9,0,5.4-2.4,5.4-5.4V50.2C210.4,49.3,210.1,48.4,209.5,47.7L209.5,47.7z M170.3,17.4L192.1,44h-21.8 C170.3,44,170.3,17.4,170.3,17.4z M199.8,74.6v168.6c0,0,0,0.1-0.1,0.1H10.6c0,0-0.1,0-0.1-0.1V10.6c0,0,0-0.1,0.1-0.1h149.1v38.7 c0,2.9,2.4,5.3,5.3,5.3h34.8L199.8,74.6L199.8,74.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument01);
export default __webpack_public_path__ + "static/media/Document-01.bd5530430602f0361e3b3d54a975718b.svg";
export { ForwardRef as ReactComponent };